import React from 'react';
import { useTranslation } from 'react-i18next';
import useStyles from 'hooks/useStyles';
import { array } from 'prop-types';
import styles from './InstructorAbout.scss';

function InstructorAbout({ aboutList }) {
  useStyles(styles);
  const { t } = useTranslation(['instructorProfile']);

  const renderAboutList = ({ content, description, iconUrl }) => {
    return (
      <li className={styles.listItem} key={content}>
        <img src={iconUrl} alt={content} className={styles.icon} />
        <div>
          <h5 className={styles.itemTitle}>{content} </h5>
          <p className={styles.description}>{description}</p>
        </div>
      </li>
    );
  };
  return (
    <>
      <h4 className={styles.title}> {t('instructorProfile.about')} </h4>
      <ul className={styles.list}>{aboutList.map(renderAboutList)}</ul>
    </>
  );
}
InstructorAbout.propTypes = {
  aboutList: array.isRequired,
};
export default InstructorAbout;
